import React from "react";

function Certification() {

  return (<div className="filter">
    <h3>Certification</h3>
    <ul className="genres-nav">
        <li>U</li>
        <li>UA</li>
        <li>A</li>
    </ul>
  </div>);
}

export default Certification;
